<template>
    <div>

        <v-toolbar flat dense app :clipped-left="clipped" color="primary">

            <v-toolbar-side-icon @click.stop="drawer()" class="white--text"/>
            <v-toolbar-title v-text="title" class="white--text"/>
            <v-spacer/>
            <v-btn icon >
                <v-icon>minus</v-icon>
            </v-btn>

        </v-toolbar>

        <v-container fluid>
            <!--<v-slide-y-transition mode="out-in">-->
            <v-layout column align-center>
                <br/>
                <img src="@/assets/logo.png" alt="CA-Tecnicos 2" class="mb-5">
                <blockquote>
                    <footer>
                        <small>
                            <em>Versão: <b>{{VERSION}}</b></em>
                        </small>
                    </footer>
                </blockquote>
            </v-layout>
            <br/>
            <v-alert type="error" :icon="'cached'" :value="show">
                ATUALIZAÇÃO DISPONÍVEL
            </v-alert>
            <!--</v-slide-y-transition>-->
        </v-container>

    </div>
</template>

<script>
    import { EventBus } from "../utils/event-bus.js";
    import { Me } from "../class/me";
    export default {
        data () {
            return {
                clipped: false,
                title: "CA-Tecnicos 2",
                VERSION: null,
                show: false
            };
        },
        beforeMount () {
            // eslint-disable-next-line no-undef
            this.VERSION = VERSION;
            Me.version().then((data) => {
                if (data.data.version !== this.VERSION) {
                    this.show = true;
                }
            });
        },
        methods: {
            drawer: () => {
                EventBus.$emit("drawer", true);
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>
